module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/wasm/3617be715d91bbd3627ad5a82908648e.wasm";